import { Translator } from 'Translator';
import Load from 'components/Load';
import LoadingDots from 'components/LoadingDots';
import useIsMobile from 'hooks/useIsMobile';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import Notfound from 'modules/errorpages/Notfound';
import LoggedOut from 'modules/user-environment2/components/LoggedOut';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import basePath from 'utils/basePath';
import { useUser } from '~/authentication/store';

const HostStatusManagementPage = Load(
  () =>
    import(
      /* webpackChunkName: "host-manage-status" */ './containers/HostStatusManagementPage'
    ),
);
const DeactivationPage = Load(
  () =>
    import(
      /* webpackChunkName: "host-deativate" */ './containers/DeactivationPage'
    ),
);
const SuccessPageContainer = Load(
  () =>
    import(
      /* webpackChunkName: "host-status-success" */ './containers/SuccessPageContainer'
    ),
);

const SubRoutes = () => {
  const { path } = useRouteMatch();
  const { isHost, isAdmin, loading, isLoggedIn } = useUser();
  const isMobile = useIsMobile();

  if (!loading && !isLoggedIn) {
    return <LoggedOut title={'Login to view this content'} />;
  }

  if (loading) {
    return <LoadingDots />;
  }

  if (!isHost && !isAdmin) {
    return (
      <Redirect
        to={generatePathnameWithLangCode('/', Translator.getLanguageCode())}
      />
    );
  }

  return (
    <Switch>
      <NavigationableLayout
        key="host-deactivation"
        path={`${path}/deactivation`}
        hideFooter
        component={DeactivationPage}
        showBottomNavigation
        noNavbar={isMobile}
        nonFixedNavbar
        exact
      />
      <NavigationableLayout
        key="host-deactivation"
        path={`${path}/success`}
        hideFooter
        component={SuccessPageContainer}
        showBottomNavigation
        noNavbar={isMobile}
        nonFixedNavbar
        exact
      />
      <NavigationableLayout
        key="host-manage-status"
        path={`${path}/`}
        hideFooter
        component={HostStatusManagementPage}
        showBottomNavigation
        noNavbar={isMobile}
        nonFixedNavbar
        exact
      />
      <Route>
        <Notfound />
      </Route>
    </Switch>
  );
};

const routes = (
  <Route path={`${basePath}/host/manage-status`}>
    <>
      <SubRoutes />
      <AppBottomPushDown />
    </>
  </Route>
);

export default routes;
